import './index.less';

import { collector, storeChannelInfo } from '@bfe/by-data-pool';
import { RUNTIME_ENV } from '@bfe/by-env';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useLoginModal } from '@/hooks/useLoginModal';
import { useUserProfile } from '@/hooks/useUserProfile';
import { useUserStore } from '@/store/useUser';
import { complianceShow } from '@/utils/complianceHelpers';
import { BYBIT_TOKEN_COOKIE_KEY, cookieDomain } from '@/utils/constants';
import { replaceContentDomain } from '@/utils/constants/common';
import { navigateApp } from '@/utils/deeplink';
import storage from '@/utils/storage';
import isApp from '@/utils/ua';

import FeedbackBox from './components/FeedbackBox/FeedbackBox';

const UserFeedbackInner = () => {
  const { t: $t, i18n } = useTranslation('user-feedback');
  const { userInfo, updateUserProfile } = useUserProfile();
  const { openLoginModal } = useLoginModal(() => {
    window.location.reload();
  });

  const { complianceConfig } = useUserStore();

  useEffect(() => {
    try {
      // 存储代理商邀请码等信息到cookie
      storeChannelInfo(RUNTIME_ENV);
      collector.start();
    } catch (error) {
      console.log('大数据上报失败');
    }
  }, []);

  const updatesLink = () => {
    const path = `https://blog.bybit.com/${i18n.language}/post/bybit-listens-derivatives-trading-blt7a15708182b60698/`;
    const frPath =
      'https://blog.bybit.com/fr-FR/post/bybit-te-escuta-trading-derivativos-blt7a15708182b60698/';
    const brPath =
      'https://blog.bybit.com/pt-BR/post/bybit-sizleri-dinliyor-vadeli-islemler-blt7a15708182b60698/';
    const ruPath =
      'https://blog.bybit.com/ru-RU/post/bybit-listens-derivatives-trading-jp-blt7a15708182b60698/';

    const enLangs = ['en', 'en-US', 'fil-PH', 'kk-KZ', 'uk-UA', 'hi-IN'];

    if (enLangs.includes(i18n.language)) {
      return replaceContentDomain(path);
    }

    if (i18n.language === 'fr-FR') {
      return replaceContentDomain(frPath);
    }

    if (i18n.language === 'pt-BR') {
      return replaceContentDomain(brPath);
    }

    if (i18n.language === 'ru-RU') {
      return replaceContentDomain(ruPath);
    }

    return replaceContentDomain(path);
  };

  const startTrade = () => {
    if (isApp()) {
      if (userInfo.id) {
        navigateApp('/trade/inverse/BTCUSD');
      } else {
        navigateApp('/register');
      }
    } else {
      const link = userInfo.id ? '/trade/inverse/BTCUSD' : '/register';
      window.location.href = link;
    }
  };

  const initAppToken = async () => {
    try {
      const { default: Hecate } = await import('@bybit/hecate');
      await Hecate.ready();
      Hecate.UserProfile.getUserProfile({
        needLogin: true,
        forceUpdate: true,
      })
        .then((res: any) => {
          const token = res.params ? res.params.userToken : '';
          if (token) {
            storage.cookie.set(BYBIT_TOKEN_COOKIE_KEY, token, {
              expires: 7,
              path: '/',
              domain: cookieDomain,
            });
            updateUserProfile();
            // window.location.reload();
          }
        })
        .catch((error: any) => {
          console.log('app登陆态获取失败', error);
        });
    } catch (error) {
      console.log('feedback error', error);
    }
  };

  const login = () => {
    if (isApp()) {
      initAppToken();
    } else {
      openLoginModal();
    }
  };

  useEffect(() => {
    if (isApp()) {
      initAppToken();
    }
  }, []);

  return (
    <>
      <div className="main">
        <div className="intro">
          <em className="icon-light-outline"></em>
          <span dangerouslySetInnerHTML={{ __html: $t('feedbackIntroBody') }} />
        </div>
        <div className="feedback-box-wrap">
          <FeedbackBox onLogin={login} />
        </div>
        <div className="founder-wrap">
          <div className="founder-message">
            <div className="avatar">
              <img
                src="/common-static/cht-static/user-svc/img/user-feedback/founder-new.png"
                alt=""
              />
            </div>
            <div className="message-wrap">
              <div className="message">{$t('feedbackFounderMessage')}</div>
              <div className="name">{$t('feedbackFounder')}</div>
            </div>
          </div>
          {complianceShow(complianceConfig?.FeedbackSeeUpdatesEntry) && (
            <div className="see-updates">
              <div className="icon-blog-outline"></div>
              <div className="see-updates-text">
                {$t('feedbackUpdatesMessage')}
              </div>
              <div className="see-updates-btn">
                <a
                  className="see-updates-link"
                  href={updatesLink()}
                  target="_blank"
                  rel="noreferrer"
                >
                  {$t('feedbackSeeUpdatesText')}
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="start-trading">
        <div className="start-trading-inner">
          <div className="content">{$t('startTrading')}</div>
          <button
            className="start-btn"
            onClick={() => {
              startTrade();
            }}
          >
            {$t('getStart')}
          </button>
        </div>
      </div>
    </>
  );
};

export default UserFeedbackInner;
